import { useEffect } from 'react';
import { AddressVerificationCard } from './addressVerification/AddressVerificationCard';
import { DebtVerificationCard } from './debtVerification/DebtVerificationCard';
import { useSelector } from 'react-redux';
import { selectDebtVerificationStatus } from '../../../../../features/user/verificationSlices/debtVerificationSlice';
import { selectAddressVerificationStatus } from '../../../../../features/user/verificationSlices/addressVerifcationSlice';
import { useLocation, useNavigate } from 'react-router-dom';

export const AllVerificationCard = () => {
  const debtVerified = useSelector(selectDebtVerificationStatus);
  const addressVerified = useSelector(selectAddressVerificationStatus);

  const userHasBVN = useSelector((state) => Boolean(state.user.data?.bvn));
  const userHasAddress = useSelector((state) =>
    Boolean(state.user.data?.residentialAddress)
  );

  const location = useLocation();
  const navigate = useNavigate();

  const cameFromCheckout = location.state?.fromCheckout === true;

  // Check if both verifications are done
  const bothVerified =
    (debtVerified || userHasBVN) && (addressVerified || userHasAddress);

  useEffect(() => {
    // Only redirect if the user came from checkout and both verifications are complete
    if (cameFromCheckout && bothVerified) {
      navigate('/cart-items/checkout', { replace: true });
    }
  }, [cameFromCheckout, bothVerified, navigate]);

  return (
    <ul className="w-full md:w-[789px] grid gap-4">
      {/* <IdVerificationCard /> */}
      <AddressVerificationCard />
      <DebtVerificationCard />
    </ul>
  );
};
